import { User, Database } from ".";
import Model from "./Model";

export default class DatabaseUser extends Model {
  static type = "databaseUsers";

  user: User;
  database: Database;

  monitorTarget?: number;
  surveysCount: number;
  // Present only when the database involves the patient.
  patientProgress?: { patients: number; wavesDue: number; wavesCompleted: number };

  get fullname() {
    return this.user.firstName + " " + this.user.lastName;
  }
}
